import { ValueGetterParams } from "ag-grid-community";
import { roundValue } from "lib/number";
import { referenceMetricValueOrCompute } from "../sibling-value-getter";
import { MetricsKind } from "../types";
import { MergedColumnFormulaOptions } from "./types";
import { getChildrenUnits } from "./units";

/**
 * All this function does is averaging values from children rows.
 */
export const AVERAGE_UNITS = (
    _values: number[],
    options: MergedColumnFormulaOptions,
    gridGetterParams: ValueGetterParams
) => {
    const unitsValue = referenceMetricValueOrCompute(
        () => getChildrenUnits(options, gridGetterParams),
        gridGetterParams,
        MetricsKind.UNITS
    );

    // Bail out sooner. No point doing heavy calculation of the whole rows if current value is 0.
    if (unitsValue === undefined || isNaN(unitsValue)) {
        return 0;
    }

    const numberOfDoors = options?.doors.length ?? 0;
    if (numberOfDoors === 0) {
        return 0;
    }

    return unitsValue > 0 ? roundValue(unitsValue / numberOfDoors, options.decimal) : 0;
};
